import type { DivClassType } from 'types/divClassType';

export class DivConst {
  static readonly items = {
    role: {
      admin: { label: '管理者', value: 10 },
      editor: { label: '編集者', value: 20 },
    },
    loginRoute: {
      mail: { label: 'メール', value: 10 },
    },
    companyMemberStatus: {
      invited: { label: '招待中', value: 10 },
      participated: { label: '参加済', value: 20 },
    },
    contentsType: {
      quiz: { label: 'クイズ', value: 10 },
      diagnosis: { label: '診断', value: 20 },
      form: { label: 'フォーム', value: 30 },
      voiceChat: { label: 'ボイスチャット', value: 40 },
    },
    quizStatus: {
      unpublished: { label: '未稼働', value: 10 },
      reserved: { label: '稼働（予約）', value: 20 },
      published: { label: '稼働', value: 30 },
    },
    diagnosisStatus: {
      unpublished: { label: '未稼働', value: 10 },
      reserved: { label: '稼働（予約）', value: 20 },
      published: { label: '稼働', value: 30 },
    },
    formStatus: {
      unpublished: { label: '未稼働', value: 10 },
      reserved: { label: '稼働（予約）', value: 20 },
      published: { label: '稼働', value: 30 },
    },
    voiceChatStatus: {
      unpublished: { label: '未稼働', value: 10 },
      reserved: { label: '稼働（予約）', value: 20 },
      published: { label: '稼働', value: 30 },
    },
    quizRespondentMail: {
      beginning: { label: 'クイズ開始前', value: 10 },
      afterAnswer: { label: 'クイズ回答結果前', value: 20 },
      none: { label: '項目取得なし', value: 30 },
    },
    diagnosisRespondentMail: {
      beginning: { label: '診断開始前', value: 10 },
      afterAnswer: { label: '診断結果前', value: 20 },
      none: { label: '項目取得なし', value: 30 },
    },
    formRespondentMail: {
      beginning: { label: 'フォーム開始前', value: 10 },
      afterAnswer: { label: 'フォーム回答結果前', value: 20 },
      none: { label: '項目取得なし', value: 30 },
    },
    voiceChatRespondentMail: {
      beginning: { label: 'ボイスチャット開始前', value: 10 },
      afterAnswer: { label: 'ボイスチャット回答後', value: 20 },
      none: { label: '取得しない', value: 30 },
    },
    voiceChatQuestionMode: {
      explainAndAnswer: { label: '説明＋回答', value: 10 },
      explainOnly: { label: '説明のみ', value: 20 },
    },
    voiceChatVoice: {
      female: { label: '女性（標準）', value: 10 },
      male: { label: '男性', value: 20 },
    },
    transcriptStatus: {
      pending: { label: '未処理', value: 10 },
      done: { label: '完了', value: 20 },
      failed: { label: '失敗', value: 30 },
    },
    respondentFieldDiv: {
      standard: { label: '標準項目', value: 10 },
      custom: { label: '自由項目', value: 20 },
    },
    lineFlag: {
      disable: { label: '連携しない', value: 10 },
      enable: { label: '連携する', value: 20 },
    },
    respondentStandardFieldDiv: {
      mailAddress: { label: 'メールアドレス', value: 10 },
      name: { label: '名前', value: 20 },
      gender: { label: '性別', value: 30 },
      birthDate: { label: '生年月日', value: 40 },
      phoneNumber: { label: '電話番号', value: 50 },
      residence: { label: '居住エリア', value: 60 },
    },
    respondentCustomFieldDiv: {
      custom01: { label: '自由項目01', value: 10 },
      custom02: { label: '自由項目02', value: 20 },
      custom03: { label: '自由項目03', value: 30 },
    },
    respondentCustomFieldNameDiv: {
      customField01: { label: 'customField01', value: 10 },
      customField02: { label: 'customField02', value: 20 },
      customField03: { label: 'customField03', value: 30 },
    },
    respondentCustomFieldInputDiv: {
      text: { label: '文字', value: 10 },
      numeric: { label: '数字', value: 20 },
    },
    respondentCustomFieldMaxLength: {
      maxLength20: { label: '20文字', value: 20 },
      maxLength100: { label: '100文字', value: 100 },
      maxLength300: { label: '300文字', value: 300 },
    },
    prefecture: {
      hokkaido: { label: '北海道', value: 1 },
      aomori: { label: '青森県', value: 2 },
      iwate: { label: '岩手県', value: 3 },
      miyagi: { label: '宮城県', value: 4 },
      akita: { label: '秋田県', value: 5 },
      yamagata: { label: '山形県', value: 6 },
      fukushima: { label: '福島県', value: 7 },
      ibaraki: { label: '茨城県', value: 8 },
      tochigi: { label: '栃木県', value: 9 },
      gunma: { label: '群馬県', value: 10 },
      saitama: { label: '埼玉県', value: 11 },
      chiba: { label: '千葉県', value: 12 },
      tokyo: { label: '東京都', value: 13 },
      kanagawa: { label: '神奈川県', value: 14 },
      niigata: { label: '新潟県', value: 15 },
      toyama: { label: '富山県', value: 16 },
      ishikawa: { label: '石川県', value: 17 },
      fukui: { label: '福井県', value: 18 },
      yamanashi: { label: '山梨県', value: 19 },
      nagano: { label: '長野県', value: 20 },
      gifu: { label: '岐阜県', value: 21 },
      shizuoka: { label: '静岡県', value: 22 },
      aichi: { label: '愛知県', value: 23 },
      mie: { label: '三重県', value: 24 },
      shiga: { label: '滋賀県', value: 25 },
      kyoto: { label: '京都府', value: 26 },
      osaka: { label: '大阪府', value: 27 },
      hyogo: { label: '兵庫県', value: 28 },
      nara: { label: '奈良県', value: 29 },
      wakayama: { label: '和歌山県', value: 30 },
      tottori: { label: '鳥取県', value: 31 },
      shimane: { label: '島根県', value: 32 },
      okayama: { label: '岡山県', value: 33 },
      hiroshima: { label: '広島県', value: 34 },
      yamaguchi: { label: '山口県', value: 35 },
      tokushima: { label: '徳島県', value: 36 },
      kagawa: { label: '香川県', value: 37 },
      ehime: { label: '愛媛県', value: 38 },
      kochi: { label: '高知県', value: 39 },
      fukuoka: { label: '福岡県', value: 40 },
      saga: { label: '佐賀県', value: 41 },
      nagasaki: { label: '長崎県', value: 42 },
      kumamoto: { label: '熊本県', value: 43 },
      oita: { label: '大分県', value: 44 },
      miyazaki: { label: '宮崎県', value: 45 },
      kagoshima: { label: '鹿児島県', value: 46 },
      okinawa: { label: '沖縄県', value: 47 },
      abroad: { label: '海外', value: 48 },
    },
    gender: {
      male: { label: '男性', value: 10 },
      female: { label: '女性', value: 20 },
      other: { label: 'その他', value: 30 },
      noAnswer: { label: '回答しない', value: 40 },
    },
    batch: {
      publish: { label: '公開バッチ', value: 10 },
      quizSummary: { label: 'クイズ集計バッチ', value: 20 },
      diagnosisSummary: { label: '診断集計バッチ', value: 30 },
      remindPlan: { label: 'プランリマインドバッチ', value: 40 },
      rePublishContents: { label: 'コンテンツ再公開バッチ', value: 50 },
    },
    termsInputType: {
      url: { label: 'URL', value: 10 },
      text: { label: 'テキスト', value: 20 },
    },
    questionType: {
      text: { label: '文字', value: 1 },
      numeric: { label: '数字', value: 2 },
      radio: { label: 'ラジオボタン', value: 3 },
      checkbox: { label: 'チェックボックス', value: 4 },
      select: { label: 'セレクトボックス', value: 5 },
      image: { label: '画像のボタン', value: 6 },
    },
    questionOptionLimit: {
      radio: 15,
      checkbox: 15,
      select: 50,
      image: 4,
    },
    questionCountLimit: {
      voiceChat: 10,
    },
    questionDefault: {
      defaultRequiredFlag: true,
      textMaxLength: '100',
      numberMaxLength: '20',
      checkboxMaxCount: '3',
      checkboxMinCount: '0',
    },
  };
  static QuizStatusDiv: DivClassType;
}
